module.exports = __webpack_public_path__ + "static/media/truck-icon.8ece9531.svg";